import { RouteButtonLink } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import Button, { type ButtonProps } from "@mui/material/Button";

type MUIButtonLinkProps = ButtonProps<"a">;

export interface HybridRouteButtonLinkProps extends MUIButtonLinkProps {
  url: string;
}

export const HybridRouteButtonLink: React.FC<HybridRouteButtonLinkProps> = ({
  url,
  children,
  ...rest
}) => {
  // Temporary disable React Router DOM link because Rails with React don't correctly handle the link
  if (window.reactWithRails) {
    return (
      <Button component="a" href={url} {...rest}>
        {children}
      </Button>
    );
  }

  return (
    <RouteButtonLink to={url} {...rest}>
      {children}
    </RouteButtonLink>
  );
};
